import errorHandler from "common/errorHandler";
import { call, put, takeLatest } from "redux-saga/effects";
import { Endpoints } from "services/api";
import * as actions from "./actions";

function* getDataSyndicationSubscriptionList(api) {
    let result = yield call([api, api.get], `${Endpoints.dataSyndication}/api/v1/subscriptions`);
    return result.data;
}

function* getDataSyndicationSubscription(api, subscriptionId) {
    let result = yield call([api, api.get], `${Endpoints.dataSyndication}/api/v1/subscriptions/item/${subscriptionId}`);
    return result.data;
}

function* confirmDataSyndicationSubscription(api, subscriptionId, confirmSubscriptionParams) {
    let result = yield call([api, api.put], `${Endpoints.dataSyndication}/api/v1/subscriptions/item/${subscriptionId}/confirm`, confirmSubscriptionParams);
    return result.data;
}

function* getSubscriptionSourceDataSets(api, subscriptionId) {
    let result = yield call([api, api.get], `${Endpoints.dataSyndication}/api/v1/subscriptions/item/${subscriptionId}/source/datasets`);
    return result.data;
}

function* deleteDataSyndicationSubscription(api, subscriptionId) {
    let result = yield call([api, api.delete], `${Endpoints.dataSyndication}/api/v1/subscriptions/item/${subscriptionId}`);
    return result.data;
}

export function* getDataSyndicationSubscriptionListRequest(api) {
    try {
        const result = yield call(getDataSyndicationSubscriptionList, api);
        yield put(actions.getDataSyndicationSubscriptionListSuccess(result));
    } catch (error) {
        let errorObject = errorHandler(error, "Get", "data syndication subscription list");
        yield put(actions.getDataSyndicationSubscriptionListFailure(errorObject));
    }
}

export function* getDataSyndicationSubscriptionRequest(api, { params }) {
    try {
        const result = yield call(getDataSyndicationSubscription, api, params.subscriptionId);
        yield put(actions.getDataSyndicationSubscriptionSuccess(result));
    } catch (error) {
        let errorObject = errorHandler(error, "Get", "data syndication subscription");
        yield put(actions.getDataSyndicationSubscriptionFailure(errorObject));
    }
}

export function* confirmDataSyndicationSubscriptionRequest(api, { params }) {
    try {
        const result = yield call(confirmDataSyndicationSubscription, api, params.subscriptionId, {
            targetBusinessAreaId: params.targetBusinessAreaId,
            targetSchemaId: params.targetSchemaId,
            sourceDataSetId: params.sourceDataSetId,
            targetDataSetId: params.targetDataSetId,
            includeExistingRecords: params.includeExistingRecords,
        });
        yield put(actions.confirmDataSyndicationSubscriptionSuccess(params.subscriptionId, result));
    } catch (error) {
        let errorObject = errorHandler(error, "Confirm", "data syndication subscription");
        yield put(actions.confirmDataSyndicationSubscriptionFailure(params.subscriptionId, errorObject));
    }
}

function* getSubscriptionSourceDataSetsRequest(api, { params }) {
    try {
        const dataSets = yield call(getSubscriptionSourceDataSets, api, params.subscriptionId);
        yield put(actions.getSubscriptionSourceDataSetsSuccess(dataSets));
    } catch (error) {
        let errorObject = errorHandler(error, "Get", "subscription source data sets");
        yield put(actions.getSubscriptionSourceDataSetsFailure(errorObject));
    }
}

export function* deleteDataSyndicationSubscriptionRequest(api, { params }) {
    try {
        yield call(deleteDataSyndicationSubscription, api, params.subscriptionId);
        yield put(actions.deleteDataSyndicationSubscriptionSuccess(params.subscriptionId));
    } catch (error) {
        let errorObject = errorHandler(error, "Delete", "data syndication subscription");
        yield put(actions.deleteDataSyndicationSubscriptionFailure(params.subscriptionId, errorObject));
    }
}

export function* watchGetDataSyndicationSubscriptionListRequest(api, params) {
    yield call(getDataSyndicationSubscriptionListRequest, api);
}

export function* watchGetDataSyndicationSubscriptionRequest(api, params) {
    yield call(getDataSyndicationSubscriptionRequest, api, params);
}

export function* watchConfirmDataSyndicationSubscriptionRequest(api, params) {
    yield call(confirmDataSyndicationSubscriptionRequest, api, params);
}

export function* watchGetSubscriptionSourceDataSetsRequest(api, params) {
    yield call(getSubscriptionSourceDataSetsRequest, api, params);
}

export function* watchDeleteDataSyndicationSubscriptionRequest(api, params) {
    yield call(deleteDataSyndicationSubscriptionRequest, api, params);
}

export default function* ({ api }) {
    yield takeLatest(actions.GET_DATA_SYNDICATION_SUBSCRIPTION_LIST_REQUEST, watchGetDataSyndicationSubscriptionListRequest, api);
    yield takeLatest(actions.GET_DATA_SYNDICATION_SUBSCRIPTION_REQUEST, watchGetDataSyndicationSubscriptionRequest, api);
    yield takeLatest(actions.CONFIRM_DATA_SYNDICATION_SUBSCRIPTION_REQUEST, watchConfirmDataSyndicationSubscriptionRequest, api);
    yield takeLatest(actions.GET_SUBSCRIPTION_SOURCE_DATA_SETS_REQUEST, watchGetSubscriptionSourceDataSetsRequest, api);
    yield takeLatest(actions.DELETE_DATA_SYNDICATION_SUBSCRIPTION_REQUEST, watchDeleteDataSyndicationSubscriptionRequest, api);
}
